module.exports = __webpack_public_path__ + "static/flags/LA-340176a699547627532f7b4031504365.gif";